import { z } from 'zod';

// ----------- TCPA Disclosure -----------
/** Standardized TCPA consent disclosure template. All phone-collecting forms must use this exact text. */
const TCPA_DISCLOSURE_TEMPLATE = 'By providing your telephone number and submitting this form, you agree that [Dealer] may call or text you regarding your inquiry. You may opt out at any time by replying STOP. Msg frequency varies. Msg and data rates may apply.';
/** Build TCPA disclosure text with dealer name substituted in. Falls back to "the dealership" for empty or missing names. */
function buildTcpaDisclosureText(dealerName) {
    return TCPA_DISCLOSURE_TEMPLATE.replace('[Dealer]', dealerName || 'the dealership');
}
const tcpaConsentMetadataSchema = z.object({
    consentedAt: z.string(),
    disclosureText: z.string(),
    formUrl: z.string(),
});

export { TCPA_DISCLOSURE_TEMPLATE, buildTcpaDisclosureText, tcpaConsentMetadataSchema };
//# sourceMappingURL=tcpa.js.map
